import {
    XML_GET_FAILURE,
    XML_GET_REQUEST,
    XML_GET_SUCCESS,
} from "../actions/actionTypes";

const initialState = {
    xml: [],
    loading: false,
    error: null,
};

const xmlReducer = (state = initialState, action) => {
    switch (action.type) {
        case XML_GET_REQUEST:
            return { ...state, loading: true, error: null };
        case XML_GET_SUCCESS:
            return { ...state, loading: false, xml: action.payload };
        case XML_GET_FAILURE:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};

export default xmlReducer;
